
define('text!views/shared/header/balance.html',[],function () { return '<%- this.account_balance %>';});

